export default __webpack_public_path__ + "static/media/quiz_graphic.35a09e78.svg";